import { Link } from "react-router-dom";

/**
 * Small teaser ad-box on Browse for the Find the Needle contest.
 * Whole banner is a link to the full public /contest landing page — where
 * QR visitors and members alike see prize details, rules, and drawing time.
 *
 * Rendered whenever there is a contest configured (open, closed, or between
 * weeks) so the /contest page always has an entry point from Browse. The
 * prize thumbnail is a stable filename swapped monthly — see PRIZE config
 * at the top of /pages/Contest.jsx.
 */
export default function NeedleContestBanner({ contest }) {
  // Unused prop kept in the signature to preserve the current call-site
  // contract in Browse.jsx and future admin toggles.
  void contest;
  return (
    <Link
      to="/contest"
      data-testid="browse-needle-contest-banner"
      className="group block mb-4 border border-[#FFD700]/40 bg-gradient-to-r from-[#FFD700]/10 via-[#0a0a0a] to-[#FF5F1F]/10 hover:border-[#FFD700] transition-colors"
    >
      <div className="flex items-center gap-3 md:gap-4 p-2.5 md:p-3">
        {/* Prize thumbnail — swap /graphics/needle-prize-current.png monthly */}
        <img
          src="/graphics/needle-prize-current.png"
          alt="This month's Find the Needle grand prize"
          loading="lazy"
          data-testid="needle-prize-thumb"
          className="w-14 h-14 md:w-16 md:h-16 shrink-0 object-contain rounded-sm bg-black/40"
        />

        <div className="flex-1 min-w-0">
          <div className="font-display font-black uppercase tracking-tight text-sm md:text-base text-white leading-tight">
            Find the Needle — <span className="text-[#FFD700]">Win the Prize!</span>
          </div>
          <div className="mt-0.5 text-[11px] md:text-xs text-zinc-300 truncate">
            Click here for details on the <span className="text-white font-semibold">Great Needle Hunt</span>.
          </div>
        </div>

        {/* CTA chevron */}
        <span
          aria-hidden="true"
          className="shrink-0 font-mono text-[10px] md:text-xs uppercase tracking-widest text-[#FFD700] group-hover:text-[#FF5F1F] transition-colors"
        >
          Details →
        </span>
      </div>
    </Link>
  );
}
